<template>
  <a-modal v-model:visible="pennantsVisible" title="锦旗详情" :footer="null">
    <div class="pennants_container">
      <div class="main">
        <auth-img mode="ant" :width="140" :src="pennantsDetail.pennantUrl" alt="" />
        <div class="imgText">
          <auth-img mode="ant" :preview="false" :src="pennantsDetail.pennantTextUrl" alt="" />
        </div>
        <span class="name">赠送人：{{ pennantsDetail.rewardName || '--' }}</span>
      </div>
      <a-divider />
      <div class="label">
        <p>患者留言：</p>
        <p>
          {{ pennantsDetail.rewardContent || '--' }}
        </p>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineProps } from 'vue'
import { pennantRewardDetail } from '@/api/workPlace/pennants'

const props = defineProps({
  pennantsId: {
    type: String,
    default: ''
  }
})

const pennantsDetail = ref({})
const pennantsInitDetail = () => {
  pennantRewardDetail({ pennantRewardRecordId: props.pennantsId }).then(res => {
    pennantsDetail.value = res
  })
}

const pennantsVisible = ref(false)
defineExpose({
  pennantsVisible,
  pennantsInitDetail
})
</script>
<style lang="scss" scoped>
.pennants_container {
  padding: 0 20px 60px;
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      min-width: 167px;
      text-align: center;
      line-height: 42px;
      background: #ffeeda;
      border-radius: 21px;
      color: #ffaa4d;
      font-weight: 550;
      font-size: 16px;
      padding: 0 10px;
    }
    .imgText {
      width: 112px;
      height: 40px;
      overflow: hidden;
      margin: 20px 0;
    }
  }
  .label {
    p:nth-of-type(1) {
      font-weight: 550;
      font-size: 16px;
      color: #1a1a1a;
      margin-bottom: 8px;
    }
    p:nth-of-type(2) {
      font-weight: 400;
      font-size: 16px;
      color: #7d7d7d;
    }
  }
}
</style>
